export const SET_LOADING = "SET_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";